@if (loaded()) {
  <div
    class="section-container"
    [ngClass]="{ 'has-children': section.children?.length > 0 }"
  >
    <!-- Group header: will only highlight if it has no children -->
    <div
      class="section"
      [ngClass]="{ selected: isSelected(section) }"
      (click)="!section.children?.length && onSectionClick(section.id)"
      (keyup.enter)="!section.children?.length && onSectionClick(section.id)"
      [attr.tabindex]="section.children?.length ? null : '0'"
      [attr.role]="section.children?.length ? null : 'button'"
    >
      <hyperkit-typography
        class="section-title"
        variant="emphasized"
        size="sm"
        align="left"
        color="primary"
      >
        {{ section.title }}
      </hyperkit-typography>
    </div>
    <!-- Only render & enable clicks on true subsections -->
    @if (section.children?.length) {
      <div class="subsections">
        @for (child of section.children; track child) {
          <div class="subsection-item">
            <div
              class="subsection"
              [ngClass]="{ selected: isSelected(child) }"
              (click)="onSectionClick(child.id)"
              (keyup.enter)="onSectionClick(child.id)"
              tabindex="0"
              role="button"
            >
              <hyperkit-typography
                class="subsection-title"
                variant="emphasized"
                size="sm"
                align="left"
                color="primary"
              >
                {{ child.title }}
              </hyperkit-typography>
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <p>Loading…</p>
}
